import { CONSULTATION_COPY } from '../../constants/consultation';

export const FAQ_DATA = [
  {
    question: 'Is the consultation free?',
    answer: 'Yes—no pressure, no obligation.',
  },
  {
    question: 'How long is it?',
    answer: 'The consultation is 30 minutes.',
  },
  {
    question: 'Do I need to prepare?',
    answer: 'Just your goals or questions; a brief form helps us tailor the call.',
  },
  {
    question: 'Where do sessions happen?',
    answer: 'Secure video or phone, based on your preference.',
  },
];

export const FAQ_CONTENT = {
  title: 'Frequently Asked Questions',
  buttonText: CONSULTATION_COPY.book,
};
